export default __webpack_public_path__ + "static/study-seminar2-56a25ee5798752eb585fc523cf1ec0b1.jpg";